import axios from "axios";
import { jwtDecode } from "jwt-decode";

// Crear una instancia de axios sin interceptores globales para el login
const loginAxios = axios.create();

export async function LoginService(userData, isCompleteLogin = false) {
  try {
    // SIEMPRE respetar REACT_APP_API si está definida
    const backendUrl = process.env.REACT_APP_API || 'http://127.0.0.1:5001';
    
    // Debug: verificar qué valor tiene REACT_APP_API
    console.log('[LoginService] REACT_APP_API:', process.env.REACT_APP_API);
    console.log('[LoginService] backendUrl:', backendUrl);
    
    // Determinar si estamos en desarrollo local (solo si REACT_APP_API apunta a localhost o no está definida)
    const isLocal = !process.env.REACT_APP_API || 
                    process.env.REACT_APP_API.includes('localhost') || 
                    process.env.REACT_APP_API.includes('127.0.0.1');
    
    const isDevelopment = isLocal;
    
    // Construir la URL de la API
    // Si REACT_APP_API está definida, SIEMPRE usar URL completa (no rutas relativas)
    // Las rutas relativas solo funcionan cuando nginx está configurado (producción desplegada)
    let apiUrl;
    const endpoint = isCompleteLogin ? '/security/auth/complete-login' : '/security/auth';
    
    if (process.env.REACT_APP_API) {
      // REACT_APP_API está definida: usar URL completa directamente
      apiUrl = `${backendUrl}${endpoint}`;
      console.log('[LoginService] Usando URL completa (REACT_APP_API definida):', apiUrl);
    } else if (isDevelopment) {
      // Desarrollo local sin REACT_APP_API: usar backend local
      apiUrl = `${backendUrl}${endpoint}`;
      console.log('[LoginService] Usando URL desarrollo local:', apiUrl);
    } else {
      // Producción desplegada sin REACT_APP_API: usar ruta relativa /v1/... (nginx las maneja)
      apiUrl = `/v1${endpoint}`;
      console.log('[LoginService] Usando ruta relativa (producción):', apiUrl);
    }
    
    const response = await loginAxios.post(
      apiUrl,
      userData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const { token, companyId, hasMultipleCompanies, companies } = response.data;

    // Si hay múltiples compañías, retornar esa información
    if (hasMultipleCompanies && companies) {
      return {
        hasMultipleCompanies: true,
        companies
      };
    }

    if (token) {
      const userJwt = jwtDecode(token);
      let info = { ...userJwt, token, companyId };
      
      // Si el rol no está en el JWT, obtenerlo del perfil del usuario
      if (!info.role) {
        try {
          // SIEMPRE respetar REACT_APP_API si está definida
          const backendUrl = process.env.REACT_APP_API || 'http://127.0.0.1:5001';
          
          const isLocal = !process.env.REACT_APP_API || 
                          process.env.REACT_APP_API.includes('localhost') || 
                          process.env.REACT_APP_API.includes('127.0.0.1');
          
          const isDevelopment = isLocal;
          
          let profileUrl;
          if (process.env.REACT_APP_API) {
            // REACT_APP_API está definida: usar URL completa directamente
            profileUrl = `${backendUrl}/users/profile`;
          } else if (isDevelopment) {
            // Desarrollo local sin REACT_APP_API: usar backend local
            profileUrl = `${backendUrl}/users/profile`;
          } else {
            // Producción desplegada sin REACT_APP_API: usar ruta relativa /v1/... (nginx las maneja)
            profileUrl = '/v1/users/profile';
          }
          
          const profileResponse = await loginAxios.get(
            profileUrl,
            {
              headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );
          if (profileResponse.data && profileResponse.data.role) {
            info.role = profileResponse.data.role;
          }
        } catch (profileError) {
          console.warn("No se pudo obtener el perfil del usuario:", profileError);
          // Si no se puede obtener el perfil, usar 'user' por defecto
          info.role = info.role || 'user';
        }
      }
      
      localStorage.setItem("authUser", JSON.stringify({ ...info }));
      return true;
    }
  } catch (err) {
    // Axios siempre incluye la respuesta en err.response si el servidor respondió
    // Si err.response existe, el servidor respondió con un error
    // Si no existe, fue un error de red o conexión
    console.log("Error en LoginService - err completo:", err);
    console.log("Error en LoginService - err.response:", err.response);
    console.log("Error en LoginService - err.response?.data:", err.response?.data);
    
    // Re-lanzar el error con toda la información para que el componente pueda manejarlo
    throw err;
  }
}
